import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { withRouter} from 'react-router-dom';
import Iframe from 'react-iframe'
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    textColor:{
        color: '#a52423'
    },
    divStyle:{
        paddingLeft:'0px',
        paddingTop:'30px',
        width:'100vw',
        textAlign:'center',
        height:'700px',
    },
    padding:{
        padding:'10px'
    },
    subText:{
        color: '#a52423',
        paddingLeft:'30px'
    }
});

class ArbitrationRules extends Component {
    
    state = {
        numPages: null,
        pageNumber: 1,
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    componentWillUpdate(){

    }

    componentDidMount(){
            // window.location.replace(`${process.env.REACT_APP_SERVER_HOSTNAME}:3000/onlinearb.pdf`);
            //this.props.history.push(`${this.props.match.url}onlinearb.pdf`);
            document.getElementById("myId").style.position = "";
            document.getElementById("myId").style.display = "";

    }

    render(){
        
        const { classes, file } = this.props;
        let { numPages, pageNumber } = this.state;
        // let fileURL = __dirname + 'onlinearb.html'
        //changed
        let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=onlinearb`;
        return (
            <div className={classes.divStyle}>
                
                <Iframe 
                    url={fileURL}
                    width="90vw"
                    height="75vh"
                    style={{position:"",display:""}}
                    id="myId"
                    // className="myClassname"
                    // position="absolute"
                />
                
            </div>
        );
    }

}



export default withStyles(styles)(withRouter(ArbitrationRules));